module.exports = __webpack_public_path__ + "img/joushinji_logo_white_separate_second.1e05f2cf.png";